export const live = {
    zbz: "Canlı Yayında",
    ljks: "Hemen Başlat",
    hmyzb: "Henüz canlı yayın yapmadınız~",
    zbyg: "Canlı Yayın Ön İzleme",
    yjs: "Sonlandı",
    jszb: "Yayını Sonlandır",
    gbzb: "Yayını Kapat",
    jxzb: "Yayına Devam Et",
    bctp: "Resmi Kaydet",
    fxlj: "Bağlantıyı Paylaş",
    zbydk: "Canlı yayın kesildi, lütfen bekleyin...",
    fh: "Geri Dön",
    wjcdypsb: "Ses cihazı tespit edilmedi",
    czsb: "Canvas işlemi başarısız:",
    tpjzsb: "Resim yüklenemedi, lütfen URL'nin doğru ve resme erişilebilir olduğunu kontrol edin",
    zbjl: "Yayın Geçmişi",
    sqjl: "Başvuru Geçmişi",
    lts: "Sohbet Odası",
    ren: "kişi",
    gdcy: "Daha Fazla Üye",
    cy: "Üyeler",
    jcjy: "Susturmayı Kaldır",
    jy: "Sustur",
    qbjy: "Herkesi Sustur",
    zbjs: "Yayın Açıklaması",
    srnr: "Lütfen içerik girin",
    tczbj: "Yayından atıldınız",
    qd: "Onayla",
    zbjjjs: "Yayınınız 10 dakika içinde otomatik olarak sonlanacak!",
    zbsc: "Yayın Süresi:",
    ljgkrs: "Toplam İzleyici:",
    dzs: "Beğeni Sayısı:",
    zbjies: "Yayın Sonlandı",
    ybjy: "Susturuldunuz",
    jycg: "Susturma Kaldırıldı",
    jinycg: "Başarıyla Susturuldu",
    qbjinycg: "Herkes Başarıyla Susturuldu",
    qbjycg: "Herkesin Susturulması Kaldırıldı",
    cwzb: "Yayıncı Ol",
    lxgzry: "Yayıncı olmak için lütfen personelimizle iletişime geçin",
    lxfs: "İletişim Bilgileri",
    zb: "Canlı Yayın",
    xkt: "Biking Dersleri",
    sqzb: "Yayın Başvurusu",
    bczbzt: "Bu Yayının Konusu",
    srzt: "Lütfen konu girin",
    bczbjj: "Bu Yayının Açıklaması",
    kbsj: "Yayın Başlangıç Saati",
    xzrisj: "Tarih ve Saat Seçin",
    tishi: "Uyarı",
    dksdzb: "Bu saatte başlaması planlanan 1 yayın bulunuyor",
    cxsj: "Yayın Süresi",
    xzsc: "Süre Seçin",
    fmt: "Kapak Görseli",
    fmtbnwk: "Kapak görseli boş olamaz",
    sc: "Yükle",
    yssc: "Maks. 10MB, lütfen sıkıştırarak yükleyin",
    sccct: "Lütfen 360*170 boyutunda resim yükleyin",
    tjsq: "Başvuruyu Gönder",
    tpcj: "Resim Kırpma",
    tzcjwz: "Kırpma çerçevesini ayarlayın, korunacak alanı seçin",
    scdtp: "Yüklenen Resim",
    yl: "Ön İzleme (360×170)",
    cjtp: "Resmi Kırp",
    quxiao: "İptal",
    qsrzbjj: "Lütfen yayın açıklamasını girin",
    qxzrq: "Lütfen tarih seçin",
    qxzsc: "Lütfen süre seçin",
    kssjdydqsj: "Başlangıç saati şu anki saatten ileri olmalıdır",
    sctxtpdx: "Yüklenen resim boyutu 10MB'ı aşamaz!",
    tjcg: "Başarıyla Gönderildi",
    jkshnr: "Başvurunuzu en kısa sürede inceleyeceğiz",
    hmysqgzb: "Henüz yayın başvurusunda bulunmadınız~",
    shz: "İnceleniyor",
    tongg: "Onaylandı",
    jujue: "Reddedildi",
    yugao: "Ön İzleme",
    huifang: "Tekrar",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/tr.js